import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';
import {Observable} from 'rxjs';
import {Pair} from '../code-review/code-review-models';



@Injectable({
  providedIn: 'root'
})
export class ElkExceptionService {

  constructor(
    private http: HttpClient,
    private baseUrl: BaseurlService,
  ) { }

  getExceptions(dateGreaterThan?: string): Observable<Pair<ElkSearchMetadata, JsonExceptionHolder>[][]> {
    let url = `${this.baseUrl.getBaseUrl()}/elk_exceptions`;
    if (dateGreaterThan) {
      url += `?dateGreaterThan=${encodeURIComponent(dateGreaterThan)}`;
    }
    return this.http.get<Pair<ElkSearchMetadata, JsonExceptionHolder>[][]>(url);
  }

  addToBlacklist(tbl: ElkExceptionTempSilence[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl.getBaseUrl()}/elk_exceptions/tmp_id_blacklist`, tbl);
  }
}

export interface ElkSearchMetadata {
  index: string;
  id: string;
}

export interface JsonExceptionHolder {
  '@timestamp': string;
  message: string;
  r: string;
  u: string;
  application: string;
  hostname: string;
  stacktrace: string;
}

export interface ElkExceptionTempSilence {
  id: number;
  index: string;
  elkId: string;
  date: string;
}
